export const statisticsData = [
  [
    {
      head: 'Savings',
      number: 61,
      id: 'savings'
    },
    {
      head: 'Proceeds from sale of primary residence',
      number: 38,
      id: 'proceeds'
    }
  ],
  [
    {
      head: 'Gift from relative or friend',
      number: 12,
      id: 'gift'
    },
    {
      head: 'Sale of stocks or bonds',
      number: 9,
      id: 'sale'
    }
  ],
  [
    {
      head: '401k loan',
      number: 7,
      id: 'loan401k'
    },
    {
      head: 'Inheritance',
      number: 4,
      id: 'inheritance'
    }
  ],
  [
    {
      head: 'Tax refund',
      number: 4,
      id: 'tax'
    },
    {
      head: 'Loan from friend or relative',
      number: 2,
      id: 'loan'
    }
  ]
];
